import usePrivateAxios from "@/common/api/usePrivateAxios";
import { BillingEventData, BillingEventReponse } from "@/common/types/billing/event.type";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

type UseBillingEventType = ({ }: { id?: string; }) => UseQueryResult<BillingEventData, unknown>;

const useBillingEvent: UseBillingEventType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<BillingEventReponse, unknown, BillingEventData>({
    enabled: !!id,
    queryKey: ['billingEvent', id],
    queryFn: () => {
      return privateAxios.get(`/billing/events/${id}`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useBillingEvent;
